import { render, staticRenderFns } from "./DateHistogramSlider.vue?vue&type=template&id=f5d2b5dc&scoped=true&"
import script from "./DateHistogramSlider.vue?vue&type=script&lang=js&"
export * from "./DateHistogramSlider.vue?vue&type=script&lang=js&"
import style0 from "./DateHistogramSlider.vue?vue&type=style&index=0&id=f5d2b5dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d2b5dc",
  null
  
)

export default component.exports